/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// import PersonClient from 'wc-api-person';
import jwtDecode from 'jwt-decode';

let currentJWT = '';

// Get the value of environment variable with given variableName
export const getEnv = (variableName) => {
    const windowHostname = (typeof window !== 'undefined') && window.location && window.location.hostname;

    // Client/SSR: Default from local ENV vars
    let value = process.env[variableName];

    // Client: Pull from config-map generate env.js
    if (windowHostname && (window.mbp && window.mbp.env)) {
        value = window.mbp.env[variableName];

        if (!value && variableName === 'APP_WC_HOST') {
            value = window.location.hostname;
        }
    }

    // SSR: Pull from SSR specific ENV vars
    if (!windowHostname) {
        value = process.env[`${variableName}_SSR`];
    }

    return value || process.env[variableName];
};

const isGuestToken = (decodedJWT) => {
    if (decodedJWT) {
        const f = decodedJWT['https://800-flowers.net'];
        if (f && f.type) {
            return (f.type === 'guest');
        }
    }

    return false;
};

const isExpired = (decodedJWT) => {
    if (!decodedJWT.exp) {
        return false;   // token without .exp never expires
    }

    const expirationUTCInMilliseconds = decodedJWT.exp * 1000;

    const timeNow = new Date();
    const UTCNowInMilliseconds = timeNow.getTime();

    return (expirationUTCInMilliseconds < UTCNowInMilliseconds);
};

export const testJWT = (jwt) => {
    if (!jwt) {
        return { isValid: false };
    }

    try {
        const decodedJWT = jwtDecode(jwt);
        return {
            isValid: true,
            isGuest: isGuestToken(decodedJWT),
            isExpired: isExpired(decodedJWT),
        };
    } catch (error) {
        return { isValid: false };
    }
};

// Return a promise which returns the current JWT token.
// If there is no current JWT, it will get a new guest JWT.
// If current token is an expired guest token,  it will get a new guest JWT.
// If current token is not a guest token (e.g. a user token set with setJWT),
// it is returned without any expiration checking.
export async function getJWT() {
    const t = testJWT(currentJWT);
    if (!t.isValid || (t.isGuest && t.isExpired)) {
        // currentJWT = await newGuestToken();
    }

    return currentJWT;
}

// Set the current JWT.  Use this, e.g., to store a user JWT from login.
export function setJWT(token) {
    currentJWT = token;
}
